module.exports = __webpack_public_path__ + "img/Component 20.c680ebd9.png";